<template>
  <div class="goods" style="padding: 0">
    <!--<van-nav-bar title="提交成功" left-arrow @click-left="onClickLeft" style="height: 1.28rem"/>-->

    <div style="width: 100%;text-align: center;font-size: .378rem;color: #999;line-height: .574rem;background: #fff;display: inline-block;margin-bottom: .324rem">
      <div class="flex-center" style="margin: .64rem auto 0;">
        <img src="../../image/index10.png" alt="" style="width: 3.28rem;">
      </div>
      <div>
        <div style="color: #333;font-size: .45rem;font-weight: bold;">您的信息已提交成功！</div>
        <div style="margin: 0.18rem 0 1.1rem;font-size: .35rem;">评估师将会在短时间内联系您，请注意来电</div>
      </div>
    </div>
    <div class="successdetail" style="background: #fff;">
      <div style="font-size: .378rem;padding: 0.4rem 0.405rem .2rem;font-weight: bold;">订单信息</div>
      <!--<van-cell-group>-->
        <!--<van-field class="flex-start" v-for="item,index in information" v-bind:label="item.name" v-bind:value="item.infor" disabled/>-->
      <!--</van-cell-group>-->
      <div class="van-cell" v-for="item,index in information">
        <div style="width: 2.4rem">{{item.name}}</div>
        <div style="width: 6.7rem;color: #333;font-weight: 400;">{{item.infor}}</div>
      </div>
    </div>

    <div class="flex-center" style="width: 100%;background: #fff;margin-top: .324rem;padding: .324rem 0;">
      <div class="flex-center" style="background: #e9081a;color: #fff;font-size: .432rem;width: 90%;height: 1.188rem;border-radius: .594rem;" @click="toxcx">继续购物</div>
    </div>

  </div>
</template>

<script>
    import {
        Icon,
        NavBar,
        Field
    } from 'vant';

    import request from '@/utils/request'
    export default {
        components: {
            [Icon.name]: Icon,
            [NavBar.name]: NavBar,
            [Field.name]: Field
        },

        data() {
            return {
                information:[
                    {name:"订单单号",infor:""},
                    {name:"姓名",infor:""},
                    {name:"手机号",infor:""},
                    {name:"车型",infor:""},
                    {name:"上牌时间",infor:""},
                    {name:"行驶里程",infor:""},
                    {name:"咨询门店",infor:""},
                    {name:"地址",infor:""}
                ]
            };
        },

        methods: {
            onClickLeft() {
                this.$router.push('/Collect/Publish');
            },
            toxcx(){
                wx.miniProgram.switchTab({
                    url: '/pages/main/index/index'//小程序链接首页
                });
            }
        },
        mounted: function () {
            var _this=this;
            var id=_this.$route.query.id;
            console.log(id)
            if(_this.$store.state.token == undefined){
                request({
                    url: '/used_car/retail/collectCar/one',
                    method: 'GET',
                    data:{
                        id:id
                    }
                }).then(res=>{
                    console.log(res)
                    var res=res.data;
                    _this.information[0].infor=res.sn;
                    _this.information[1].infor=res.name;
                    _this.information[2].infor=res.phone;
                    _this.information[3].infor=res.modelName;
                    _this.information[4].infor=new Date(res.registrationTime).getFullYear()+'-'+(new Date(res.registrationTime).getMonth()+1)+'-'+new Date(res.registrationTime).getDate() ;
                    _this.information[5].infor=res.mileage+'km';
                    _this.information[6].infor=res.shopName;
                    _this.information[7].infor=res.shopAddress;
                });
            }else{
                request({
                    url: '/member/collectCar/one',
                    method: 'GET',
                    data:{
                        id:id
                    }
                }).then(res=>{
                    console.log(res)
                    var res=res.data;
                    _this.information[0].infor=res.sn;
                    _this.information[1].infor=res.name;
                    _this.information[2].infor=res.phone;
                    _this.information[3].infor=res.modelName;
                    _this.information[4].infor=new Date(res.registrationTime).getFullYear()+'-'+(new Date(res.registrationTime).getMonth()+1)+'-'+new Date(res.registrationTime).getDate() ;
                    _this.information[5].infor=res.mileage+'km';
                    _this.information[6].infor=res.shopName;
                    _this.information[7].infor=res.shopAddress;
                });
            }

        },

    };
</script>

<style lang="less">
  .goods {
    padding-bottom: 50px;

    &-swipe {
      img {
        width: 100%;
        display: block;
      }
    }

    &-title {
      font-size: 16px;
    }

    &-price {
      color: #f44;
    }

    &-express {
      color: #999;
      font-size: 12px;
      padding: 5px 15px;
    }

    &-cell-group {
      margin: 15px 0;

      .van-cell__value {
        color: #999;
      }
    }

    &-tag {
      margin-left: 5px;
    }
  }

  body{
    background: #F2F2F2;
  }
  .flex-start{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:flex-start;
  }
  .flex-center{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:center;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .van-nav-bar__title{
    font-size: .486rem;
    color: #333;
  }
  .van-nav-bar .van-icon{
    font-size: .486rem;
    color: #333;
  }
  .successdetail .van-cell {
    padding: 0 .405rem;
    font-size: .351rem;
    color: #999;
    border: 0;
    height: auto;
  }
  .van-field__control:disabled{
    color: #333;
  }
  .successdetail .van-cell:nth-child(2),.successdetail .van-cell:nth-child(4),.successdetail .van-cell:nth-child(7),.successdetail .van-cell:nth-child(9){
    padding-bottom: .6rem;
  }
  .successdetail .van-cell:not(:last-child)::after{
    border: 0;
  }
  .successdetail .van-field__control:disabled{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
</style>
